import { render, staticRenderFns } from "./ChangeDetectionSetCreateDialog.vue?vue&type=template&id=189a8527"
import script from "./ChangeDetectionSetCreateDialog.vue?vue&type=script&lang=js"
export * from "./ChangeDetectionSetCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports